/**
 * @file
 * Header and navigation JavaScript.
 *
 */

(function ($, Drupal, once) {
  "use strict";
  Drupal.behaviors.palantirLabHeader = {
    attach: function (context) {
      once("palantirLabHeader", "header .search-form", context).forEach(
        function (element) {
          $("body").on("click", function (e) {
            if (!e.target.closest(".search-form")) {
              $(element).removeClass("active");
            }
          });
          $(element)
            .find(".search-icon")
            .on("click", function (e) {
              $(element).addClass("active");
              var input = element.querySelector(
                '.google-cse-search-box-form input[type="text"]',
              );
              if (input) {
                input.focus();
              }
            });
          $(element)
            .find(".search-close")
            .on("click", function (e) {
              $(element).removeClass("active");
            });
        },
      );
    },
  };

  // Relocate the secondary/info-for/social menus into mobile menu.
  Drupal.behaviors.umsiMobileSecondaryNav = {
    attach: function (context) {
      once("umsiMobileSecondaryNav", ".header .tbm-main-nav", context).forEach(
        function (nav) {
          var top = nav
            .closest(".header__second")
            .querySelector(".header__second__top");
          var collapse = nav.querySelector(".tbm-collapse");
          if (!top || !collapse) {
            return;
          }

          var anchor = document.createComment("header__second__top");
          top.parentNode.insertBefore(anchor, top);

          var sync = function () {
            if (nav.classList.contains("tbm--mobile")) {
              if (top.parentNode !== collapse) {
                collapse.appendChild(top);
              }
            } else if (top.parentNode === collapse) {
              anchor.parentNode.insertBefore(top, anchor.nextSibling);
            }
          };

          sync();
          new MutationObserver(sync).observe(nav, {
            attributes: true,
            attributeFilter: ["class"],
          });
        },
      );
    },
  };
})(jQuery, Drupal, once);
